import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import profileImg from "../assets/img/profile.jpg";
import Resume from "../assets/docs/Yasharth_Resume_Tech.pdf";
export const About = () => {
    return (
        <div className='about' id = 'about'>
            <Container>
                <Row>
                    <Col size={12} md={12}>
                        <h2>About Me</h2>
                        <img src={profileImg} alt="..."/>
                        <p>Hi there! I'm a technology enthusiast who loves to learn new technologies and skills. 
                            I'm currently a final year undergraduate students at Delhi Technological Univeristy (Electrical Engineering).
                            I'm a fresher currently looking for job opportunities. <br/>
                            I've worked on various Software(ReactJS, Python, SQL) based projects as well as Hardware(Electrical & Electronics) based projects.
                            Not only that, I am also confident in my problem-solving skills and have solved great number of questions on platforms like Leetcode, GeeksForGeeks & Hackerrank. 
                            I am more of a team-working guy as well as a lone wolf. I'm determined to make my existence helpful to everyone.
                            Apart from that, I do loves to play PC and Mobile Games or Reading Books in my free time.
                        </p>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col size={12} md={6}>
                    <h3 class="big-4">Education</h3>
                    <br />
                    <div class="resume-wrap ftco-animate">
    					<h5 class="date">2020-2024</h5>
    					<h4>Bachelor of Technology (Electrical Engineering)</h4>
    					<h5 class="position">Delhi Technological University, Delhi</h5>
                        <p class="mt-4">Subjects: <br/>Power Systems | Power Electronics | Electrical Machines | Digital Electronics | Analog Electronics | Data Structures & Algorithms |
                         Object Oriented Programming | Internet Of Things | Fundamentals of Machine Learning | Data Warehousing & Data Mining</p>
    					<p class="mt-4">Current GPA: 8.81 (upto 6th semester)</p>
    				</div>
                    <div class="resume-wrap ftco-animate">
    					<h5 class="date">2018-2019</h5>
    					<h4>Higher Secondary School</h4>
    					<h5 class="position">Pandit Deen Dayal Upadhyaya Saraswati Vidya Mandir Inter College, Lakhimpur-Kheri</h5>
                        <p class="mt-4">Subjects: <br/>Physics | Chemistry | Maths | Computer Science | English | Hindi</p>
    					<p class="mt-4">Grade: 91%</p>
    				</div>
                    </Col>
                    <Col size={12} md={6}>
                    <div class="skill-mf">
									<h3 class="title-s">Skills</h3>
                                    <br />
									<span>C/C++</span> <span class="pull-right">95%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "95%"}} aria-valuenow="95" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
									
									<span>Python</span> <span class="pull-right">85%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "85%"}} aria-valuenow="85" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
									
									<span>SQL</span> <span class="pull-right">85%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "85%"}} aria-valuenow="85" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
									
									<span>React JS</span> <span class="pull-right">75%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "75%"}} aria-valuenow="75" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
									<span>Data Structures & Algorithms</span> <span class="pull-right">75%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "75%"}} aria-valuenow="75" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
                                    <span>Verilog HDL</span> <span class="pull-right">85%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "85%"}} aria-valuenow="85" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
									<span>Machine Learning</span> <span class="pull-right">50%</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" style={{width: "50%"}} aria-valuenow="50" aria-valuemin="0"
											aria-valuemax="100"></div>
									</div>
                                    <br/>
                                    <div class="about-item">
                                        <div class="abt-text">
                                            <p class="large-text">20+</p>
                                            <p class="small-text">
                                                Projects Completed
                                            </p>
                                        </div>
                                    </div>
                                    <div class="about-item">
                                        <div class="abt-text">
                                            <p class="large-text">200+</p>
                                            <p class="small-text">
                                                DSA Problems Solved
                                            </p>
                                        </div>
                                    </div>
                                    <div class="about-item">
                                        <div class="abt-text">
                                            <p class="large-text">Fresher</p>
                                            <p class="small-text">
                                                Level of Experience
                                            </p>
                                        </div>
                                    </div>
								</div>
                    </Col>
                </Row>
                <br />
                <a href={Resume}><button>Download Resume</button></a>
            </Container>
        </div>
    )
};